<section class="about-section">
  <div class="about-container d-flex flex-wrap align-items-center">
    <!-- Left side image -->
    <div class="about-image mx-3 mb-3 mb-md-0">
      <img
        src="assets/images/about/about.webp"
        alt="About Maltech"
        class="img-fluid"
        loading="lazy"
      />
    </div>

    <!-- Right side content -->
    <div class="about-content mt-5 text-md-start text-center">
      <h1>About MALtech – IT Services Company</h1>
      <p class="para">
        We are a technology-driven company delivering scalable, secure, and
        innovative IT solutions. Our expertise empowers businesses to adapt,
        grow, and thrive in the digital era. With a focus on innovation and
        reliability, we drive sustainable digital success.
      </p>
      <a
        routerLink="/contact"
        href="/contact"
        class="get-started-btn"
        rel="noopener noreferrer"
        aria-label="Let's Work Together"
      >
        Let's Work Together
      </a>
    </div>
  </div>
</section>

<section>
  <div class="who-we-are-container">
    <div class="who-we-are-inner">
      <h2 class="section-title">Who We Are</h2>
      <div class="who-we-are-content-wrapper">
        <div class="who-we-are-content">
          <p class="section-text para">
            MALtech is a trusted global partner for enterprises, providing
            comprehensive, end-to-end IT solutions that empower businesses to
            thrive in the digital era. Our expertise spans Cloud computing,
            DevOps, AI, and Machine Learning, enabling organizations to leverage
            cutting-edge technologies for smarter operations. We also specialize
            in Cybersecurity, Web, and Mobile Development, ensuring robust,
            scalable, and secure solutions for every client. By combining deep
            technical knowledge with innovative strategies, we help businesses
            stay ahead of the technology curve. Our customer-first approach
            ensures solutions are tailored to meet specific needs and deliver
            measurable value. At MALtech, we drive digital transformation by
            blending innovation, reliability, and strategic insight to create
            future-ready solutions.
          </p>
        </div>
        <div class="who-we-are-image">
          <img
            src="assets/images/about/who-maltech.webp"
            alt="A team of professionals collaborating at a desk"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="company-section mt-4">
  <div class="container">
    <h2 class="section-title1 text-center mb-4">
      Our Mission, Vision & Belief
    </h2>
    <div class="row g-4 justify-content-center">
      <div class="col-12 col-md-4" *ngFor="let card of cards">
        <div class="card h-100 text-center shadow-sm hover-card p-4 rounded">
          <div class="card-icon mb-3">
            <i class="bi fs-1" [ngClass]="card.icon"></i>
          </div>
          <div class="card-content">
            <h3 class="card-title mb-2 heading-section-card">
              {{ card.title }}
            </h3>
            <p class="card-description">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="values-section mt-5">
  <div class="container">
    <h2 class="section-title1 text-center mb-4">Company Values</h2>
    <div class="row g-4 justify-content-center">
      <!-- Individuality Card -->
      <div class="col-12 col-md-4">
        <div class="card text-center p-4 h-100 border hover-border">
          <div class="card-icon mb-3">
            <i class="bi bi-person fs-1 text-logo-color"></i>
          </div>
          <h3 class="card-title mb-2 heading-section-card text-color">Individuality</h3>
          <p class="card-description mb-0">Be the brand ambassador – be you.</p>
        </div>
      </div>

      <!-- Integrity Card -->
      <div class="col-12 col-md-4">
        <div class="card text-center p-4 h-100 border hover-border">
          <div class="card-icon mb-3">
            <i class="bi bi-shield-lock fs-1 text-logo-color"></i>
          </div>
          <h3 class="card-title mb-2 heading-section-card text-color">Integrity</h3>
          <p class="card-description mb-0">Define success with commitment.</p>
        </div>
      </div>

      <!-- Consistency Card -->
      <div class="col-12 col-md-4">
        <div class="card text-center p-4 h-100 border hover-border">
          <div class="card-icon mb-3">
            <i class="bi bi-clock fs-1 text-logo-color"></i>
          </div>
          <h3 class="card-title mb-2 heading-section-card text-color">Consistency</h3>
          <p class="card-description mb-0">
            Deliver unparalleled and collective service.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="journey-container container my-5">
  <h2 class="journey-title section-title1 text-center mb-5">
    Our Journey
  </h2>

  <div
    class="d-flex align-items-start mb-4"
    *ngFor="let item of timeline; let last = last"
  >
    <!-- ICON + LINE -->
    <div
      class="d-flex flex-column align-items-center me-3 me-md-4"
      style="min-width:48px;"
    >
      <!-- Circle Icon -->
      <div
        class="d-flex align-items-center justify-content-center rounded-circle bg-primary-icon text-white flex-shrink-0 "
       
      >
        <i class="bi fs-5 lh-1" [ngClass]="item.icon"></i>
      </div>

      <!-- Vertical Line -->
      <div
       
        class="bg-primary-line flex-grow-1"
       
      ></div>
    </div>

    <!-- CONTENT -->
    <div class="timeline-content">
      <h3 class="section-title1 mb-2">
        {{ item.year }} – {{ item.title }}
      </h3>
      <p class="timeline-description para mb-0">
        {{ item.desc }}
      </p>
    </div>
  </div>
</div>

<!-- 
  <section class="team-section container">
    <h2 class="text-center mb-5 section-title1">Our Team</h2>

    <div class="row g-4">
      <div class="col-12 col-sm-6 col-lg-3" *ngFor="let member of teamMembers">
        <div class="card h-100 text-center shadow-sm">
          <img
            [src]="member.image"
            [alt]="member.name"
            class="card-img-top team-image"
          />
          <div class="card-body">
            <h5 class="card-title">{{ member.name }}</h5>
            <p class="card-text text-muted">{{ member.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </section> -->

<div
  class="hero-section flex flex-col items-center justify-center min-h-screen p-4"
>
  <div class="text-center mt-5">
    <h2 class="hero-title">Let’s Build the Future Together.</h2>
    <p class="hero-subtitle para mobile-justify">
      Let’s build the future together with innovation and intelligence. Partner
      with MALtech to create secure, scalable, and future-ready solutions.
    </p>
  </div>
  <a
    routerLink="/contact"
    href="/contact"
    class="hero-button text-decoration-none"
    rel="noopener noreferrer"
    aria-label="Work With Us"
  >
    Work With Us
  </a>
</div>
